import DiscordIcon from '@/components/icons/DiscordIcon';
import TelegramIcon from '@/components/icons/TelegramIcon';
import { AttachMoney } from '@mui/icons-material';

export const PAYMENT_LINK_CONTENT_DELIVERY = 'disabled';
export const CAKTO_MEMBERS_V2_CONTENT_DELIVERY = 'cakto_v2';

// Tem que bater com o nome que o backend grava em ContentDelivery.name: a tela e a API
// precisam chamar cada geração do mesmo jeito, senão o produtor vê um nome e o suporte, outro.
export const MEMBERS_AREA_LABELS = {
  cakto: 'Cakto Members V1',
  cakto_v2: 'Cakto Members V2',
  cakto_v3: 'Cakto Members V3',
};

export const LEGACY_MEMBERS_AREA_SUPPORT_TOOLTIP = `O suporte para essa versão da área de membros é limitado. Recomendamos usar a ${MEMBERS_AREA_LABELS.cakto_v3} pra criar novas áreas de membros.`;

export const CONTENT_DELIVERY_OPTIONS = [
  {
    title: MEMBERS_AREA_LABELS.cakto,
    description: 'Plataforma de cursos e comunidade da Cakto',
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="currentColor" />
        <path
          d="M22.0403 14.0267L16.627 18.08"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.8732 10.1895C26.9312 11.2476 26.9312 12.9631 25.8732 14.0211C24.8151 15.0792 23.0996 15.0792 22.0416 14.0211C20.9835 12.9631 20.9835 11.2476 22.0416 10.1895C23.0997 9.13148 24.8151 9.13148 25.8732 10.1895"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.0403 25.9733L16.627 21.92"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.8732 25.9789C26.9312 27.037 26.9312 28.7524 25.8732 29.8105C24.8151 30.8685 23.0996 30.8685 22.0416 29.8105C20.9835 28.7524 20.9835 27.037 22.0416 25.9789C23.0997 24.9208 24.8151 24.9208 25.8732 25.9789"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6206 18.0862C17.6776 19.1432 17.6776 20.8569 16.6206 21.914C15.5635 22.971 13.8498 22.971 12.7928 21.914C11.7357 20.8569 11.7357 19.1432 12.7928 18.0862C13.8498 17.0291 15.5636 17.0291 16.6206 18.0862"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    value: 'cakto',
    noSupport: true,
  },
  {
    title: MEMBERS_AREA_LABELS.cakto_v2,
    description: 'Área de Membros da Cakto',
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="currentColor" />
        <path
          d="M22.0403 14.0267L16.627 18.08"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.8732 10.1895C26.9312 11.2476 26.9312 12.9631 25.8732 14.0211C24.8151 15.0792 23.0996 15.0792 22.0416 14.0211C20.9835 12.9631 20.9835 11.2476 22.0416 10.1895C23.0997 9.13148 24.8151 9.13148 25.8732 10.1895"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.0403 25.9733L16.627 21.92"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.8732 25.9789C26.9312 27.037 26.9312 28.7524 25.8732 29.8105C24.8151 30.8685 23.0996 30.8685 22.0416 29.8105C20.9835 28.7524 20.9835 27.037 22.0416 25.9789C23.0997 24.9208 24.8151 24.9208 25.8732 25.9789"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6206 18.0862C17.6776 19.1432 17.6776 20.8569 16.6206 21.914C15.5635 22.971 13.8498 22.971 12.7928 21.914C11.7357 20.8569 11.7357 19.1432 12.7928 18.0862C13.8498 17.0291 15.5636 17.0291 16.6206 18.0862"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    value: 'cakto_v2',
  },
  {
    title: MEMBERS_AREA_LABELS.cakto_v3,
    description: 'Área de Membros Premium da Cakto',
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="currentColor" />
        <path
          d="M22.0403 14.0267L16.627 18.08"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.8732 10.1895C26.9312 11.2476 26.9312 12.9631 25.8732 14.0211C24.8151 15.0792 23.0996 15.0792 22.0416 14.0211C20.9835 12.9631 20.9835 11.2476 22.0416 10.1895C23.0997 9.13148 24.8151 9.13148 25.8732 10.1895"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.0403 25.9733L16.627 21.92"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.8732 25.9789C26.9312 27.037 26.9312 28.7524 25.8732 29.8105C24.8151 30.8685 23.0996 30.8685 22.0416 29.8105C20.9835 28.7524 20.9835 27.037 22.0416 25.9789C23.0997 24.9208 24.8151 24.9208 25.8732 25.9789"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6206 18.0862C17.6776 19.1432 17.6776 20.8569 16.6206 21.914C15.5635 22.971 13.8498 22.971 12.7928 21.914C11.7357 20.8569 11.7357 19.1432 12.7928 18.0862C13.8498 17.0291 15.5636 17.0291 16.6206 18.0862"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    value: 'cakto_v3',
    recommended: true,
  },
  {
    title: 'Área de membros Externa',
    description: 'Cursos on-line e comunidade externos',
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="currentColor" />
        <path
          d="M22.0403 14.0267L16.627 18.08"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.8732 10.1895C26.9312 11.2476 26.9312 12.9631 25.8732 14.0211C24.8151 15.0792 23.0996 15.0792 22.0416 14.0211C20.9835 12.9631 20.9835 11.2476 22.0416 10.1895C23.0997 9.13148 24.8151 9.13148 25.8732 10.1895"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.0403 25.9733L16.627 21.92"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.8732 25.9789C26.9312 27.037 26.9312 28.7524 25.8732 29.8105C24.8151 30.8685 23.0996 30.8685 22.0416 29.8105C20.9835 28.7524 20.9835 27.037 22.0416 25.9789C23.0997 24.9208 24.8151 24.9208 25.8732 25.9789"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6206 18.0862C17.6776 19.1432 17.6776 20.8569 16.6206 21.914C15.5635 22.971 13.8498 22.971 12.7928 21.914C11.7357 20.8569 11.7357 19.1432 12.7928 18.0862C13.8498 17.0291 15.5636 17.0291 16.6206 18.0862"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    value: 'external',
  },
  {
    title: 'Instagram Close Friends',
    description: 'Adicione automaticamente alguém aos Close Friends',
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="url(#paint0_linear_4435_8112)" />
        <path
          d="M20.2 14.2C19.0133 14.2 17.8532 14.5518 16.8665 15.2111C15.8798 15.8704 15.1108 16.8075 14.6567 17.9039C14.2025 19.0002 14.0837 20.2066 14.3152 21.3705C14.5468 22.5344 15.1182 23.6035 15.9573 24.4426C16.7964 25.2817 17.8655 25.8532 19.0294 26.0847C20.1933 26.3162 21.3997 26.1974 22.4961 25.7432C23.5924 25.2891 24.5295 24.5201 25.1888 23.5334C25.8481 22.5467 26.2 21.3866 26.2 20.2C26.1983 18.6092 25.5656 17.084 24.4408 15.9591C23.3159 14.8343 21.7907 14.2016 20.2 14.2ZM20.2 24.2C19.4088 24.2 18.6355 23.9654 17.9777 23.5258C17.3199 23.0863 16.8072 22.4616 16.5044 21.7307C16.2017 20.9998 16.1225 20.1955 16.2768 19.4196C16.4312 18.6437 16.8121 17.9309 17.3715 17.3715C17.9309 16.8121 18.6437 16.4312 19.4196 16.2768C20.1955 16.1225 20.9998 16.2017 21.7307 16.5044C22.4616 16.8072 23.0863 17.3199 23.5258 17.9777C23.9654 18.6355 24.2 19.4088 24.2 20.2C24.2 21.2608 23.7785 22.2782 23.0284 23.0284C22.2782 23.7785 21.2608 24.2 20.2 24.2ZM26.2 7.19995H14.2C12.344 7.20194 10.5647 7.94007 9.2524 9.2524C7.94007 10.5647 7.20194 12.344 7.19995 14.2V26.2C7.20194 28.0559 7.94007 29.8352 9.2524 31.1475C10.5647 32.4598 12.344 33.198 14.2 33.2H26.2C28.0559 33.198 29.8352 32.4598 31.1475 31.1475C32.4598 29.8352 33.198 28.0559 33.2 26.2V14.2C33.198 12.344 32.4598 10.5647 31.1475 9.2524C29.8352 7.94007 28.0559 7.20194 26.2 7.19995ZM31.2 26.2C31.2 27.526 30.6732 28.7978 29.7355 29.7355C28.7978 30.6732 27.526 31.2 26.2 31.2H14.2C12.8739 31.2 11.6021 30.6732 10.6644 29.7355C9.72674 28.7978 9.19995 27.526 9.19995 26.2V14.2C9.19995 12.8739 9.72674 11.6021 10.6644 10.6644C11.6021 9.72674 12.8739 9.19995 14.2 9.19995H26.2C27.526 9.19995 28.7978 9.72674 29.7355 10.6644C30.6732 11.6021 31.2 12.8739 31.2 14.2V26.2ZM28.2 13.7C28.2 13.9966 28.112 14.2866 27.9472 14.5333C27.7823 14.78 27.5481 14.9722 27.274 15.0858C26.9999 15.1993 26.6983 15.229 26.4073 15.1711C26.1163 15.1133 25.8491 14.9704 25.6393 14.7606C25.4295 14.5508 25.2867 14.2836 25.2288 13.9926C25.1709 13.7016 25.2006 13.4 25.3141 13.1259C25.4277 12.8518 25.6199 12.6176 25.8666 12.4527C26.1133 12.2879 26.4033 12.2 26.7 12.2C27.0978 12.2 27.4793 12.358 27.7606 12.6393C28.0419 12.9206 28.2 13.3021 28.2 13.7Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_4435_8112"
            x1="11.5"
            y1="40"
            x2="29.5"
            y2="6.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFB34E" />
            <stop offset="0.52" stopColor="#F9514A" />
            <stop offset="1" stopColor="#C837AB" />
          </linearGradient>
        </defs>
      </svg>
    ),
    value: 'instagram_cf',
  },
  {
    title: 'Instagram Perfil Privado',
    description: 'Permita o acesso automático a um perfil privado ',
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="url(#paint0_linear_4435_8112)" />
        <path
          d="M20.2 14.2C19.0133 14.2 17.8532 14.5518 16.8665 15.2111C15.8798 15.8704 15.1108 16.8075 14.6567 17.9039C14.2025 19.0002 14.0837 20.2066 14.3152 21.3705C14.5468 22.5344 15.1182 23.6035 15.9573 24.4426C16.7964 25.2817 17.8655 25.8532 19.0294 26.0847C20.1933 26.3162 21.3997 26.1974 22.4961 25.7432C23.5924 25.2891 24.5295 24.5201 25.1888 23.5334C25.8481 22.5467 26.2 21.3866 26.2 20.2C26.1983 18.6092 25.5656 17.084 24.4408 15.9591C23.3159 14.8343 21.7907 14.2016 20.2 14.2ZM20.2 24.2C19.4088 24.2 18.6355 23.9654 17.9777 23.5258C17.3199 23.0863 16.8072 22.4616 16.5044 21.7307C16.2017 20.9998 16.1225 20.1955 16.2768 19.4196C16.4312 18.6437 16.8121 17.9309 17.3715 17.3715C17.9309 16.8121 18.6437 16.4312 19.4196 16.2768C20.1955 16.1225 20.9998 16.2017 21.7307 16.5044C22.4616 16.8072 23.0863 17.3199 23.5258 17.9777C23.9654 18.6355 24.2 19.4088 24.2 20.2C24.2 21.2608 23.7785 22.2782 23.0284 23.0284C22.2782 23.7785 21.2608 24.2 20.2 24.2ZM26.2 7.19995H14.2C12.344 7.20194 10.5647 7.94007 9.2524 9.2524C7.94007 10.5647 7.20194 12.344 7.19995 14.2V26.2C7.20194 28.0559 7.94007 29.8352 9.2524 31.1475C10.5647 32.4598 12.344 33.198 14.2 33.2H26.2C28.0559 33.198 29.8352 32.4598 31.1475 31.1475C32.4598 29.8352 33.198 28.0559 33.2 26.2V14.2C33.198 12.344 32.4598 10.5647 31.1475 9.2524C29.8352 7.94007 28.0559 7.20194 26.2 7.19995ZM31.2 26.2C31.2 27.526 30.6732 28.7978 29.7355 29.7355C28.7978 30.6732 27.526 31.2 26.2 31.2H14.2C12.8739 31.2 11.6021 30.6732 10.6644 29.7355C9.72674 28.7978 9.19995 27.526 9.19995 26.2V14.2C9.19995 12.8739 9.72674 11.6021 10.6644 10.6644C11.6021 9.72674 12.8739 9.19995 14.2 9.19995H26.2C27.526 9.19995 28.7978 9.72674 29.7355 10.6644C30.6732 11.6021 31.2 12.8739 31.2 14.2V26.2ZM28.2 13.7C28.2 13.9966 28.112 14.2866 27.9472 14.5333C27.7823 14.78 27.5481 14.9722 27.274 15.0858C26.9999 15.1993 26.6983 15.229 26.4073 15.1711C26.1163 15.1133 25.8491 14.9704 25.6393 14.7606C25.4295 14.5508 25.2867 14.2836 25.2288 13.9926C25.1709 13.7016 25.2006 13.4 25.3141 13.1259C25.4277 12.8518 25.6199 12.6176 25.8666 12.4527C26.1133 12.2879 26.4033 12.2 26.7 12.2C27.0978 12.2 27.4793 12.358 27.7606 12.6393C28.0419 12.9206 28.2 13.3021 28.2 13.7Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_4435_8112"
            x1="11.5"
            y1="40"
            x2="29.5"
            y2="6.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFB34E" />
            <stop offset="0.52" stopColor="#F9514A" />
            <stop offset="1" stopColor="#C837AB" />
          </linearGradient>
        </defs>
      </svg>
    ),
    value: 'instagram_pp',
  },
  {
    title: 'Link de pagamento',
    description: 'Utilize exclusivamente o link de pagamento para receber os valores',
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="currentColor" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8787 22.9947L11.832 13.3334H28.6667C29.5347 13.3334 30.1707 14.148 29.96 14.9907L28.1627 22.18C27.8894 23.272 26.9614 24.0747 25.8414 24.1867L16.7534 25.096C15.3987 25.2307 14.16 24.3254 13.8787 22.9947Z"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.8321 13.3334L10.9654 9.33337H8.66675"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.8117 29.6893C26.5424 29.6893 26.3237 29.908 26.3264 30.1773C26.3264 30.4466 26.5451 30.6653 26.8144 30.6653C27.0837 30.6653 27.3024 30.4466 27.3024 30.1773C27.3011 29.908 27.0824 29.6893 26.8117 29.6893"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.5963 29.6894C15.327 29.6894 15.1083 29.908 15.111 30.1774C15.1083 30.448 15.3283 30.6667 15.5977 30.6667C15.867 30.6667 16.0857 30.448 16.0857 30.1787C16.0857 29.908 15.867 29.6894 15.5963 29.6894"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    value: PAYMENT_LINK_CONTENT_DELIVERY,
  },
  {
    title: 'Acesso por e-mail',
    description:
      'Envie um acesso personalizado a um drive, link, etc., para seu cliente diretamente pelo e-mail',
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="currentColor" />
        <path
          d="M13.998 16.9987L17.9003 19.4045C19.1879 20.1984 20.8132 20.1984 22.1008 19.4045L26.003 16.9987"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="7.99512"
          y="10.6627"
          width="24.01"
          height="18.6744"
          rx="4"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    value: 'emailAccess',
  },
  {
    title: 'Telegram',
    description: 'Grupo ou canal privado',
    icon: <TelegramIcon />,
    value: 'telegram',
  },
  {
    title: 'Discord',
    description:
      'Gerencie a entrada de novos usuários em um canal do Discord e monetize um servidor',
    icon: <DiscordIcon />,
    value: 'discord',
  },
  {
    title: 'E-book/Arquivos via E-mail',
    description: 'Envie e-books ou outros arquivos diretamente para o e-mail dos clientes',
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="currentColor" />
        <path
          d="M12 12H20V16H24V28H12V12Z"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 12V16H24"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    value: 'files',
  },
];

export const PRODUCTS_STATUS = {
  all: {
    label: 'Todos',
    color: 'default',
  },
  active: {
    label: 'Ativo',
    color: 'primary',
  },
  waiting: {
    label: 'Em análise',
    color: 'warning',
  },
  waiting_config: {
    label: 'Aguardando configuração',
    color: 'warning',
  },
  refused: {
    label: 'Recusado',
    color: 'error',
  },
  blocked: {
    label: 'Inativo',
    color: 'error',
  },
  draft: {
    label: 'Rascunho',
    color: 'info',
  },
  deleted: {
    label: 'Deletado',
    color: 'error',
  },
};

export const PRODUCTS_PAYMENT_TYPE = {
  unique: {
    label: 'Pagamento único',
    value: 'unique',
    icon: <AttachMoney sx={{ fontSize: 16, marginRight: 0.5 }} />,
  },
  subscription: {
    label: 'Assinatura',
    value: 'subscription',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        style={{ fontSize: 18, marginRight: 4, flexShrink: 0 }}
      >
        <path
          fill="currentColor"
          d="M15.75 6.01c.18 0 .344.063.473.168a5 5 0 0 1-3.004 8.818l-.216.004H8.56l1.22 1.22a.75.75 0 0 1 .072.976l-.072.084a.75.75 0 0 1-.977.073l-.084-.073l-2.5-2.5a.75.75 0 0 1-.072-.976l.072-.084l2.5-2.5a.75.75 0 0 1 1.133.976l-.072.084l-1.22 1.22h4.442a3.5 3.5 0 0 0 3.495-3.308l.005-.192c0-1.081-.49-2.048-1.26-2.69a.75.75 0 0 1 .508-1.3m-5.53-3.29a.75.75 0 0 1 .977-.073l.084.073l2.5 2.5l.072.084a.75.75 0 0 1 .008.882l-.08.094l-2.5 2.5l-.084.073a.75.75 0 0 1-.883.007l-.094-.08l-.072-.084a.75.75 0 0 1-.008-.882l.08-.094l1.22-1.22H7a3.5 3.5 0 0 0-3.496 3.308L3.498 10c0 1.083.492 2.051 1.265 2.693a.75.75 0 0 1-1.01 1.107a5 5 0 0 1 3.029-8.796L6.997 5h4.441L10.22 3.78l-.072-.084a.75.75 0 0 1 .072-.976"
        />
      </svg>
    ),
  },
};

export const CONTENT_DELIVERY_OPTIONS_NEW_USER_JOURNEY_PRODUCT = [
  {
    title: MEMBERS_AREA_LABELS.cakto,
    description: 'Plataforma de cursos e comunidade da Cakto',
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="currentColor" />
        <path
          d="M22.0403 14.0267L16.627 18.08"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.8732 10.1895C26.9312 11.2476 26.9312 12.9631 25.8732 14.0211C24.8151 15.0792 23.0996 15.0792 22.0416 14.0211C20.9835 12.9631 20.9835 11.2476 22.0416 10.1895C23.0997 9.13148 24.8151 9.13148 25.8732 10.1895"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.0403 25.9733L16.627 21.92"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.8732 25.9789C26.9312 27.037 26.9312 28.7524 25.8732 29.8105C24.8151 30.8685 23.0996 30.8685 22.0416 29.8105C20.9835 28.7524 20.9835 27.037 22.0416 25.9789C23.0997 24.9208 24.8151 24.9208 25.8732 25.9789"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6206 18.0862C17.6776 19.1432 17.6776 20.8569 16.6206 21.914C15.5635 22.971 13.8498 22.971 12.7928 21.914C11.7357 20.8569 11.7357 19.1432 12.7928 18.0862C13.8498 17.0291 15.5636 17.0291 16.6206 18.0862"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    value: 'cakto',
  },
  {
    title: MEMBERS_AREA_LABELS.cakto_v2,
    description: 'Área de Membros da Cakto',
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="currentColor" />
        <path
          d="M22.0403 14.0267L16.627 18.08"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.8732 10.1895C26.9312 11.2476 26.9312 12.9631 25.8732 14.0211C24.8151 15.0792 23.0996 15.0792 22.0416 14.0211C20.9835 12.9631 20.9835 11.2476 22.0416 10.1895C23.0997 9.13148 24.8151 9.13148 25.8732 10.1895"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.0403 25.9733L16.627 21.92"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.8732 25.9789C26.9312 27.037 26.9312 28.7524 25.8732 29.8105C24.8151 30.8685 23.0996 30.8685 22.0416 29.8105C20.9835 28.7524 20.9835 27.037 22.0416 25.9789C23.0997 24.9208 24.8151 24.9208 25.8732 25.9789"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6206 18.0862C17.6776 19.1432 17.6776 20.8569 16.6206 21.914C15.5635 22.971 13.8498 22.971 12.7928 21.914C11.7357 20.8569 11.7357 19.1432 12.7928 18.0862C13.8498 17.0291 15.5636 17.0291 16.6206 18.0862"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    value: 'cakto_v2',
  },
  {
    title: MEMBERS_AREA_LABELS.cakto_v3,
    description: 'Área de Membros Premium da Cakto',
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="currentColor" />
        <path
          d="M22.0403 14.0267L16.627 18.08"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.8732 10.1895C26.9312 11.2476 26.9312 12.9631 25.8732 14.0211C24.8151 15.0792 23.0996 15.0792 22.0416 14.0211C20.9835 12.9631 20.9835 11.2476 22.0416 10.1895C23.0997 9.13148 24.8151 9.13148 25.8732 10.1895"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.0403 25.9733L16.627 21.92"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.8732 25.9789C26.9312 27.037 26.9312 28.7524 25.8732 29.8105C24.8151 30.8685 23.0996 30.8685 22.0416 29.8105C20.9835 28.7524 20.9835 27.037 22.0416 25.9789C23.0997 24.9208 24.8151 24.9208 25.8732 25.9789"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6206 18.0862C17.6776 19.1432 17.6776 20.8569 16.6206 21.914C15.5635 22.971 13.8498 22.971 12.7928 21.914C11.7357 20.8569 11.7357 19.1432 12.7928 18.0862C13.8498 17.0291 15.5636 17.0291 16.6206 18.0862"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    value: 'cakto_v3',
    recommended: true,
  },
  {
    title: 'Área de membros Externa',
    description: 'Cursos on-line e comunidade externos',
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="currentColor" />
        <path
          d="M22.0403 14.0267L16.627 18.08"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.8732 10.1895C26.9312 11.2476 26.9312 12.9631 25.8732 14.0211C24.8151 15.0792 23.0996 15.0792 22.0416 14.0211C20.9835 12.9631 20.9835 11.2476 22.0416 10.1895C23.0997 9.13148 24.8151 9.13148 25.8732 10.1895"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.0403 25.9733L16.627 21.92"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.8732 25.9789C26.9312 27.037 26.9312 28.7524 25.8732 29.8105C24.8151 30.8685 23.0996 30.8685 22.0416 29.8105C20.9835 28.7524 20.9835 27.037 22.0416 25.9789C23.0997 24.9208 24.8151 24.9208 25.8732 25.9789"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6206 18.0862C17.6776 19.1432 17.6776 20.8569 16.6206 21.914C15.5635 22.971 13.8498 22.971 12.7928 21.914C11.7357 20.8569 11.7357 19.1432 12.7928 18.0862C13.8498 17.0291 15.5636 17.0291 16.6206 18.0862"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    value: 'external',
  },
  {
    title: 'Link de pagamento',
    description: 'Utilize exclusivamente o link de pagamento para receber os valores',
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="currentColor" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8787 22.9947L11.832 13.3334H28.6667C29.5347 13.3334 30.1707 14.148 29.96 14.9907L28.1627 22.18C27.8894 23.272 26.9614 24.0747 25.8414 24.1867L16.7534 25.096C15.3987 25.2307 14.16 24.3254 13.8787 22.9947Z"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.8321 13.3334L10.9654 9.33337H8.66675"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.8117 29.6893C26.5424 29.6893 26.3237 29.908 26.3264 30.1773C26.3264 30.4466 26.5451 30.6653 26.8144 30.6653C27.0837 30.6653 27.3024 30.4466 27.3024 30.1773C27.3011 29.908 27.0824 29.6893 26.8117 29.6893"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.5963 29.6894C15.327 29.6894 15.1083 29.908 15.111 30.1774C15.1083 30.448 15.3283 30.6667 15.5977 30.6667C15.867 30.6667 16.0857 30.448 16.0857 30.1787C16.0857 29.908 15.867 29.6894 15.5963 29.6894"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    value: PAYMENT_LINK_CONTENT_DELIVERY,
  },
  {
    title: 'Acesso por e-mail',
    description:
      'Envie um acesso personalizado a um drive, link, etc., para seu cliente diretamente pelo e-mail',
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="currentColor" />
        <path
          d="M13.998 16.9987L17.9003 19.4045C19.1879 20.1984 20.8132 20.1984 22.1008 19.4045L26.003 16.9987"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="7.99512"
          y="10.6627"
          width="24.01"
          height="18.6744"
          rx="4"
          stroke="#36B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    value: 'emailAccess',
  },
  {
    title: 'Telegram',
    description: 'Grupo ou canal privado',
    icon: <TelegramIcon />,
    value: 'telegram',
  },
  {
    title: 'Discord',
    description:
      'Gerencie a entrada de novos usuários em um canal do Discord e monetize um servidor',
    icon: <DiscordIcon />,
    value: 'discord',
  },
];

export const RECURRENCE_CREATE_PRODUCT = [
  { label: 'Semanal', value: 7, name: 'weekly' },
  { label: 'Mensal', value: 30, name: 'monthly' },
  {
    label: 'Trimestral',
    value: 90,
    name: 'quarterly',
  },
  {
    label: 'Semestral',
    value: 180,
    name: 'semiannual',
  },
  {
    label: 'Anual',
    value: 365,
    name: 'yearly',
  },
];

export const RADIO_OPTIONS_CREATE_PRODUCT = [
  {
    value: 'Até o cliente cancelar',
    label: 'Até o cliente cancelar',
  },
  {
    value: 'Número limitado de cobranças',
    label: 'Número limitado de cobranças',
  },
];

export const ACCESS_PERIOD_CREATE_PRODUCT = [
  {
    name: 'week',
    label: 'Semana',
    value: 7,
  },
  {
    name: 'month',
    label: 'Mês',
    value: 30,
  },
  {
    name: 'year',
    label: 'Ano',
    value: 365,
  },
  {
    name: 'lifetime',
    label: 'Vitalício',
    value: 1,
  },
];

export const TEST_PERIOD_DAYS_CREATE_PRODUCT = [7, 14, 21, 30];

export const PAYMENT_TYPES = {
  UNIQUE: 'unique',
  SUBSCRIPTION: 'subscription',
};

// Recuperação de carrinho por WhatsApp (CKTPL-1174). Quem pode ativar é decidido por conta no
// backend; ver `useWhatsappCartRecoveryEnabled`.
//
// Vive aqui, e não em cada tela, porque o texto aparece no relatório da recuperação e no aviso
// de cobrança: aviso que diverge entre telas vira disputa depois.
export const WHATSAPP_ABANDONMENT_DESCRIPTION =
  'Envia uma mensagem no WhatsApp para quem preencheu os dados no checkout mas não concluiu '
  + 'a compra, com o link para retomar de onde parou. O disparo acontece cerca de 20 minutos '
  + 'após o abandono, uma vez por carrinho e no máximo uma vez por cliente a cada 24 horas. '
  + 'O valor é debitado do seu saldo no momento do envio.';

// Fica visível no relatório, não só num tooltip: quem decide ativar precisa saber do custo
// antes de ativar, e tooltip exige hover.
//
// O preço não é fixo: é o custo da Meta em dólar convertido pelo câmbio do dia, com a margem da
// Cakto. Quem sabe o número é o backend (`useWhatsappAbandonmentPrice`), e por isso o aviso é
// montado a partir da resposta. Sem ela (carregando ou com erro), sai o mesmo aviso sem o
// número: prometer um valor que não é o do dia é pior que não mostrar valor nenhum.
const WHATSAPP_ABANDONMENT_BILLING_RULES =
  'O valor acompanha o dólar do dia, porque o WhatsApp cobra em dólar. '
  + 'Mensagem não entregue é estornada. Sem saldo disponível, o disparo não acontece.';

export const WHATSAPP_ABANDONMENT_BILLING_NOTICE =
  `Valor por mensagem enviada, descontado do seu saldo. ${WHATSAPP_ABANDONMENT_BILLING_RULES}`;

export const buildWhatsappAbandonmentBillingNotice = (priceLabel) =>
  priceLabel
    ? `${priceLabel} por mensagem enviada hoje, descontado do seu saldo. ${WHATSAPP_ABANDONMENT_BILLING_RULES}`
    : WHATSAPP_ABANDONMENT_BILLING_NOTICE;

// Compartilhado pela aba de configurações (V1) e pelo passo de configurações da edição (V2),
// para o produtor ler a mesma promessa nas duas telas.
export const CAKTO_MARKETPLACE_LABEL = 'Mostrar no Cakto Marketplace';

export const CAKTO_MARKETPLACE_DESCRIPTION =
  'Seu produto aparece na vitrine pública da Cakto, onde compradores encontram produtos sem '
  + 'precisar de conta. A compra continua no seu checkout.';

// Espelham o `renewalReminderDaysBefore` do Product no cakto-backend (CKTMF-510), que recusa
// fora da faixa. O teto de 30 é também a janela que o job do lembrete lê: subir aqui sem subir
// lá faz a tela aceitar um valor que o backend devolve como erro.
export const RENEWAL_REMINDER_DAYS_MIN = 1;
export const RENEWAL_REMINDER_DAYS_MAX = 30;
export const RENEWAL_REMINDER_DAYS_DEFAULT = 3;

export const RENEWAL_REMINDER_BLOCK_TITLE = 'Lembrete de renovação';

export const RENEWAL_REMINDER_BLOCK_DESCRIPTION =
  'E-mail que a Cakto envia ao assinante antes de cada cobrança da assinatura.';

export const RENEWAL_REMINDER_LABEL = 'Enviar lembrete de renovação ao assinante';

export const RENEWAL_REMINDER_HELPER =
  'O assinante recebe um e-mail antes de cada cobrança, com a data, o meio de pagamento e um '
  + 'botão para atualizá-lo.';

// O tooltip diz o que o produtor arrisca, não só o que ganha: o lembrete também faz o cliente
// lembrar que assina, e esconder isso tira dele a escolha que a configuração existe para dar.
export const RENEWAL_REMINDER_TOOLTIP =
  'Alguns dias antes de cada renovação, a Cakto envia ao assinante um e-mail com o produto, a '
  + 'data da cobrança e o meio de pagamento que será usado, com um botão para trocar o cartão na '
  + 'página de assinaturas. O aviso diminui reembolsos, MED e chargebacks de quem esqueceu da '
  + 'assinatura e evita recusas por cartão vencido. Como ele também lembra o cliente de que a '
  + 'assinatura existe, quem não quer mais o produto pode cancelar antes da renovação.';

export const RENEWAL_REMINDER_DAYS_LABEL = 'Enviar quantos dias antes da renovação';

export const RENEWAL_REMINDER_DAYS_HELPER =
  `Padrão: ${RENEWAL_REMINDER_DAYS_DEFAULT} dias. Assinaturas cobradas em intervalos iguais ou `
  + 'menores que esse prazo não recebem o lembrete.';

export const RENEWAL_REMINDER_DAYS_ERROR =
  `Informe um número inteiro de ${RENEWAL_REMINDER_DAYS_MIN} a ${RENEWAL_REMINDER_DAYS_MAX}.`;

export const RENEWAL_REMINDER_DAYS_COVER_CYCLE_WARNING =
  'Com essa antecedência, estas ofertas ficam sem lembrete, porque são cobradas em intervalos '
  + 'iguais ou menores que ela:';

export const RENEWAL_REMINDER_DAYS_COVER_CYCLE_HINT =
  'Para todas as ofertas receberem, use menos dias que o intervalo mais curto.';

export const RENEWAL_REMINDER_UNNAMED_OFFER = 'Oferta sem nome';

// Espelham o `flexibleRetryDate` do Product no cakto-backend (CKTMF-513). A regra mexe na data em
// que o cliente do produtor é cobrado e no tempo em atraso antes de cancelar, e isso não cabe num
// tooltip: o rótulo e o apoio dizem o que é, e o modal explica com um exemplo de datas.
export const FLEXIBLE_RETRY_DATE_BLOCK_TITLE = 'Data da cobrança';

export const FLEXIBLE_RETRY_DATE_BLOCK_DESCRIPTION =
  'Quando a Cakto tenta cobrar de novo a renovação recusada no cartão.';

export const FLEXIBLE_RETRY_DATE_LABEL = 'Flexibilizar a data da cobrança';

// A espera pelo salário só vale em ciclo de 28 dias ou mais (`MONEY_DAY_MIN_RECURRENCE_DAYS` no
// cakto-backend): na semanal e na quinzenal ela passaria do próximo ciclo. O texto precisa dizer
// isso, senão promete ao produtor de assinatura curta uma data que a regra nunca usa.
export const FLEXIBLE_RETRY_DATE_HELPER =
  'Quando o cartão do assinante é recusado por falta de saldo ou limite, as novas tentativas '
  + 'evitam fim de semana e feriado. Na assinatura mensal ou mais longa, a última fica para o dia '
  + 'do salário.';

export const FLEXIBLE_RETRY_DATE_HOW_IT_WORKS = 'Como funciona';

// O nome que o leitor de tela anuncia. Começa pelo texto visível, para quem usa comando de voz
// achar o botão pelo que vê (WCAG 2.5.3), e diz do quê: numa lista de botões da página, "Como
// funciona" sozinho não diz qual configuração ele explica.
export const FLEXIBLE_RETRY_DATE_HOW_IT_WORKS_ARIA_LABEL =
  `${FLEXIBLE_RETRY_DATE_HOW_IT_WORKS} a flexibilização da data da cobrança`;

// Sem percentual de aprovação: o número do estudo mistura primeira tentativa e retentativa, e na
// tela ele viraria uma promessa ao produtor que a regra não garante.
export const FLEXIBLE_RETRY_DATE_MODAL = {
  title: 'Flexibilizar a data da cobrança',
  withoutOption: {
    title: 'Como é sem a opção',
    text:
      'Quando a renovação no cartão é recusada por falta de saldo ou limite, a Cakto tenta cobrar '
      + 'de novo seguindo a régua da sua oferta: por padrão, 3 novas tentativas, uma por dia, '
      + 'inclusive sábado e domingo. Se todas falharem, a assinatura é cancelada.',
  },
  withOption: {
    title: 'O que muda com a opção ligada',
    items: [
      'Nenhuma nova tentativa cai em sábado, domingo ou feriado nacional. Ela passa para o '
        + 'próximo dia útil.',
      'Na assinatura mensal ou mais longa, a última tentativa fica para o dia em que o salário '
        + 'costuma cair (o 5º dia útil ou o último dia útil do mês), se ele estiver a até 10 dias.',
      'O número de tentativas continua o da sua oferta, e a cobrança do dia da renovação não muda.',
    ],
  },
  example: {
    title: 'Exemplo: cartão recusado por saldo na sexta, 23/10',
    rows: [
      {
        label: 'Sem a opção',
        text:
          'sábado 24, domingo 25 e segunda 26. Se falhar, a assinatura é cancelada antes do salário.',
      },
      {
        label: 'Com a opção',
        text: 'segunda 26, terça 27 e sexta 30, último dia útil do mês.',
      },
    ],
  },
  why: {
    title: 'Por que isso ajuda',
    text:
      'Muita gente só tem saldo depois que o salário cai. A cobrança no dia certo é aprovada mais '
      + 'vezes, e a assinatura que seria cancelada continua ativa.',
  },
  goodToKnow: {
    title: 'O que você precisa saber',
    items: [
      'Vale só para cartão recusado por falta de saldo ou limite. Cartão bloqueado, Pix '
        + 'Automático, Pix e boleto seguem como hoje.',
      // Sem teto fixo de propósito: a base de cada tentativa é a data em que a anterior rodou, então
      // os adiamentos para o dia útil se somam aos até 10 dias que a última espera pelo salário.
      'Enquanto espera a próxima tentativa, a assinatura fica em atraso, como já fica hoje entre '
        + 'as tentativas, e por mais alguns dias antes de ser cancelada: cada tentativa que cairia '
        + 'em fim de semana ou feriado passa para o dia útil seguinte, e a última pode esperar até '
        + '10 dias pelo salário.',
      'Você pode desligar quando quiser. As tentativas que já estão marcadas mantêm a data.',
    ],
  },
  close: 'Entendi',
};
